import { render, staticRenderFns } from "./orderCancellationComponent.vue?vue&type=template&id=64bc0db2"
import script from "./orderCancellationComponent.vue?vue&type=script&lang=js"
export * from "./orderCancellationComponent.vue?vue&type=script&lang=js"
import style0 from "./orderCancellationComponent.vue?vue&type=style&index=0&id=64bc0db2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports